import React from 'react';
import MultipleChoice from '../../Response/MultipleChoice';
import SFCarousel from '../../Response/Templates/SFCarousel';

interface Props {
	data: any;
	isMultiChoice?: boolean;
	shouldDisableActions?: boolean;
	handleSubmit?: Function;
	isInsideCampaign: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse?: boolean;
	langCode?: string;
	lengthArray: number;
	flyFishChangesReq: boolean;
	addUserResponse: Function;
}

const ShowAllProducts = (props: Props) => {
	return (
		<div className='shopify-all-products'>
			<SFCarousel
				data={props.data}
				shouldDisableActions={props.shouldDisableActions}
				handleSubmit={props.handleSubmit}
				isMultiChoice={props.isMultiChoice}
				isInsideCampaign={props.isInsideCampaign}
				index={props.index}
				lengthArray={props.lengthArray}
				botImageCheck={props.botImageCheck}
				logoImagePath={props.logoImagePath}
				voiceResponse={props.voiceResponse}
				langCode={props.langCode}
				flyFishChangesReq={props.flyFishChangesReq}
				addUserResponse={props.addUserResponse}
			/>
	    </div>
	);
};

export default ShowAllProducts;
